import React from 'react';

const Profiles = () => {
  return <div>Profiles - Coming Soon ( Next Phase )</div>;
};

export default Profiles;


